import React from 'react';
import { Field } from 'formik';
import { observer } from 'mobx-react-lite';
import { searchStore } from 'stores';
import { PENDING } from 'constants/actions';
import { useTranslation } from 'hooks';
import Type from 'prop-types';
import CustomerOption from '../../List/CustomerOption';
import AsyncAutocompleteField from '../../Form/AsyncAutocompleteField';
import styles from './CustomerSearch.module.css';

const CustomerSearch = observer((props) => {
  const { customers, customersFetchState } = searchStore;
  const { disabled } = props;
  const { t } = useTranslation();

  const getOptions = (searchQuery) => {
    searchStore.getCustomers({ query: searchQuery });
  };

  return (
    <Field
      name="customer"
      filterOptions={(x) => x}
      component={AsyncAutocompleteField}
      getOptionLabel={(option) => option.name}
      options={customers}
      loading={customersFetchState === PENDING}
      getOptions={getOptions}
      classes={{
        option: styles.autocompleteOption,
      }}
      textFieldProps={{
        label: t('customer'),
        margin: 'normal',
        ...props.textFieldProps,
      }}
      disabled={disabled}
      renderOption={(liProps, option, state) => {
        return <CustomerOption liProps={liProps} option={option} state={state} />;
      }}
    />
  );
});

CustomerSearch.propTypes = {
  isAssignee: Type.bool,
};

CustomerSearch.defaultProps = {
  isAssignee: false,
};

export default CustomerSearch;
